import React from 'react';
import './Ailments.css';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';

function Ailments() {
  const { language } = useLanguage();
  const t = translations[language];

  const womenAilments = [
    t.endometriosis, t.pcos, t.adenomyosis, t.fibroids
  ];
  const respiratoryAilments = [t.allergy, t.asthma, t.bronchitis];

  return (
    <div className="Ailments">
      <div className="contact-card">
        <div className="medical-symbol">⚕</div>
        <h2 className="doctor-name">Dr.LAXMI PRABHA M.D(Hom)</h2>
        <p className="registration">Reg.no 1112 - TNHMC</p>
        <p className="designation">PROFESSOR & CONSULTANT HOMOEOPATH</p>
        <div className="contact-info">
          <p className="phone">📱 +919385331477</p>
          <p className="address">TNHB B 36 SECOND FLOOR,</p>
          <p className="address">NEW GREEN PARK AVENUE,</p>
          <p className="address">OPPOSITE JOS ALUKKAS,</p>
          <p className="address">OMALUR MAIN ROAD, SALEM 636007</p>
        </div>
      </div>
      <h2 className="section-title">{t.ailmentsTreated}</h2>
      <h3 className="category-title">{t.womenAilments}</h3>
      <div className="ailments-list">
        {womenAilments.map((ailment, index) => <div key={index}>{ailment}</div>)}
      </div>
      <h3 className="category-title">{t.respiratoryAilments}</h3>
      <div className="ailments-list">
        {respiratoryAilments.map((ailment, index) => <div key={index}>{ailment}</div>)}
      </div>
    </div>
  );
}

export default Ailments;
